<template>
  <b-form-group
    label="Proje 360 Tour Linki"
    label-for="tour360_url"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje Linki"
    >
      <b-form-input
        id="tour360_url"
        v-model="dataItem.tour360_url"
        placeholder="Proje 360 Tour Linki"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

export default {
  name: 'Tour360Url',
  components: {
    BFormInput,
    BFormGroup,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
